import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=d487e7f6&scoped=true&"
import script from "./AlertMessage.vue?vue&type=script&lang=js&"
export * from "./AlertMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d487e7f6",
  null
  
)

export default component.exports